import axios from 'axios';
import { message } from '../axios/message';
import router from '../router/index'
import store from '../store/index'
const requests = axios.create({
    baseURL:"https://yuanhuihuanhuan.com/",
    // baseURL:"http://127.0.0.1:8094",
    headers: {
        UserAuthorization: `${localStorage.getItem("token")}`,
    }
})

requests.interceptors.request.use(config => {
    config.headers['UserAuthorization'] = `${localStorage.getItem("token")}`;
    return config;
}, error => {
    console.log(error);
    return Promise.reject(new Error("faile"));
})

requests.interceptors.response.use(response => {
    // 新版列表接口统一返回分页对象，兼容旧网页端原先使用的数组结构。
    if (response.data && response.data.status == 200 && response.data.data && Array.isArray(response.data.data.records)) {
        response.data.pageData = response.data.data;
        response.data.data = response.data.data.records;
    }
    if (response.data.status == 401) {
        rememberPaymentReturn();
        message.error("用户未登录")
        router.push({
            path: '/login'

        });
    } else if (response.data.status == 500) {
        message.error(response.data.desc)
    } else if (response.data.status == 402) {
        message.error(response.data.desc)
        store.state.showPassword = true
        console.log("进行弹窗验证身份");
    }else if (response.data.status == 200) {
        store.state.checkedPassword = 'false'
        if (response.data.desc != null) {
            message({
                showClose: true,
                message: response.data.desc,
                type: 'success'
            });
        }
    }else if(response.data.status == 403){
        message.error(response.data.desc)
         router.push({
            path: '/manageLogin'

        });
    }

    return response;
}, error => {
    console.log(error);

    if (error.response && error.response.status === 401) {
        rememberPaymentReturn();
        router.push({
            path: '/login'
        });
    }
    return Promise.reject(new Error("faile"));
})

function rememberPaymentReturn() {
    const path = router.currentRoute.fullPath;
    if (/^\/cashier\/\d+(\?[^#]*)?$/.test(path)) sessionStorage.setItem('webPaymentReturn', path);
}
export default requests;
